import { render, staticRenderFns } from "./text-transform-input.vue?vue&type=template&id=0534c30a&scoped=true&"
import script from "./text-transform-input.vue?vue&type=script&lang=js&"
export * from "./text-transform-input.vue?vue&type=script&lang=js&"
import style0 from "./text-transform-input.vue?vue&type=style&index=0&id=0534c30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534c30a",
  null
  
)

export default component.exports